/**
 * This service serves as an interface how a real exportService should be implemented! Do not use in Production!
 */
angular.module('Itao.IndicatorMap').factory('ExportService', function($http, mapConfig, HyperionDataService){
  'use strict';

  // ToDo: Use new Export-Service KECK or BSt instead
  // Test: Local installation like KECK
  // refactor: exportAsPdf
  // refactor: exportAsImage
  //

  var exportSettings = mapConfig.widgetExport;
  var cssUrl = exportSettings.cssUrl + '?v=61';
  var remoteUrl = exportSettings.remoteUrl + '?v=60';
  // Tests
  // remoteUrl = 'http://localhost:8081/v1/generateImage';
  // cssUrl = "https://app.keck-atlas.de/hyperion.css?v=60";

  var exportedClass = 'exported-widget itao-pluginView';
  var rootUri = jQuery('#communeUserData').data('root-uri');

  /**
   * Wraps the html with a special element to mark it as an export
   * @param htmlString
   */
  function wrapAsExportedWidget(htmlString) {
    return '<div class="' + exportedClass + '">' + htmlString + '</div>';
  }

  return {

    /**
     * @param {String} data markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @returns {Promise}
     */
    exportAsXlsx: function (data, filetype, filename) {
      var template = '<form action="/index.php?actionName=exportDataToXlsx&controllerName=AtlasJson&eID=hyperionAjax&extensionName=ItaoHyperion&pluginName=Pi102" method="post" class="hidden"> <input type="hidden" id="export-filename" name="filename" value="" /> <input type="hidden" name="filetype" id="export-filetype" value="" /> <input type="hidden" id="export-data" name="data" value="" /> <button class="btn btn-primary" type="submit"></button></form>';
      var $form = jQuery(template);

      // Add values
      $form.find('#export-data').val(JSON.stringify(data));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val(filetype);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    },


    /**
     * @param {String} data markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @returns {Promise}
     */
    exportAsCsv: function (data, filetype, filename) {
      var template = '<form action="/index.php?actionName=exportDataToCsv&controllerName=AtlasJson&eID=hyperionAjax&extensionName=ItaoHyperion&pluginName=Pi102" method="post" class="hidden"> <input type="hidden" id="export-filename" name="filename" value="" /> <input type="hidden" name="filetype" id="export-filetype" value="" /> <input type="hidden" id="export-data" name="data" value="" /> <button class="btn btn-primary" type="submit"></button></form>';
      var $form = jQuery(template);

      // Add values
      $form.find('#export-data').val(JSON.stringify(data));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val(filetype);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    },

    /**
     * Sends the given markup to an export server and save the response as an image download
     * To do this in a cross-browser way, a temporary html <form> is created, submitted and removed afterwards
     * @param {String} html markup as string
     * @param {String} filetype name of filetype
     * @param {String} filename name of the file
     * @param {Array[Int, Int]} dimensions Array containing the width and height of the widget
     * @returns {Promise}
     */
    exportAsImage: function (html, filetype, filename, dimensions) {
      convertHtmlToPng(
        {
          html: wrapAsExportedWidget(html),
          filename: filename,
          filetype: filetype,
          dimensions: dimensions.join('x'),
          cssUrl: cssUrl
        }
      );
    },

    /**
     * Sends the given markup to an export server and save the response as an image download
     * To do this in a cross-browser way, a temporary html <form> is created, submitted and removed afterwards
     * @param {String} html markup as string
     * @param {String} filename name of the file
     * @param {Array[Int, Int]} dimensions Array containing the width and height of the widget
     * @returns {Promise}
     */
    exportAsPdf: function (html, filename, dimensions) {

      // Add values
      $form.find('#export-html').val(wrapAsExportedWidget(html));
      $form.find('#export-filename').val(filename);
      $form.find('#export-filetype').val('pdf');
      $form.find('#export-dimensions').val(dimensions.join('x'));
      $form.find('#export-cssUrl').val(cssUrl);

      // Append, submit and remove from DOM
      $form.appendTo(document.body).submit();
      $form.remove();

      return true;
    }
  }

});
